import script from "./ClientWidgetFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientWidgetFrame.vue?vue&type=script&setup=true&lang=js"

import "./ClientWidgetFrame.vue?vue&type=style&index=0&id=29adca68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29adca68"]])

export default __exports__